module.exports = __webpack_public_path__ + "static/media/transactions.85e9e8fe.svg";